import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import ArtistModel from '../../model/artist.model';
import {distinctUntilChanged} from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export default class ArtistContext {
  private artistSubject = new BehaviorSubject<ArtistModel>(null);
  public selectedArtist$ = this.artistSubject.asObservable();

  public updateSelectedArtist(artist: ArtistModel) {
    this.artistSubject.next(artist);
    console.log('UPDATE SELECTED ARTIST ', this.artistSubject.getValue());
  }

  public currentArtist(): ArtistModel {
    return this.artistSubject.getValue();
  }
}
